export interface ApiResponse<T> {
  totalRecords?: number;
  message: string;
  status: boolean;
  data: T;
}
export interface EmptyApiResponse {
  message: string;
  status: boolean;
}

export enum MessageSenderDesignation {
  Driver = 0,
  SuperAdmin = 1,
  ParkingOwner = 2,
  ParkingManager = 3,
}
export enum NotificationStatus {
  BookingNotification = 9,
  MessageNotification = 10,
  CustomInvoiceNotification = 11,
  CustomInvoicePaymentReminder = 8,
  PaymentSuccessful = 3,
}

export enum PaymentStatusForMessage {
  Pending = 1,
  Completed = 2,
  CheckoutUrlGenrated = 3,
  Processing = 4,
  Failure = 5,
  PaymentLinkExpire = 6,
  PartialCancel = 7,
  InvoiceGenerated = 8,
  Cancelled = 9,
  PendingWithOffline = 10,
  RecurringPendingPayment = 11,
  DisputeCreated = 13,
  DisputeUpdated = 14,
  DisputeLoss = 15,
  DisputeExpired = 16,
}
export enum PaymentMode {
  Online = 1,
  Offline = 2,
}
export enum InvoicePaymentStatus {
  Paid = 1,
  Pending = 0,
  PaymentFailed = 2,
  InProgress = 3,
  Cancel = 4,
  CheckoutUrlGenrated = 6,
}
export enum OfflineBookingPaymentAction {
  Pay = 0,
  MarkAsPaidAndPay = 1,
  OnlyMarkAsPaid = 2,
}
export const roleRoutes = {
  SuperAdmin: 'super-admin/messages',
  ParkingManager: 'manager/messages',
  ParkingOwner: 'manager/messages',
}

export interface DriverNotesHistory {
  eventName: number;
  eventTitle: string;
  notes: string;
  dateCreated: string;
  eventCreatedBy: string;
  createdBy: string;
  id: string;
  isDeleted: string;
}

export interface CompanyList {
  totalParkingLots: number;
  occupancyRate: number;
  name: string;
  companyLogoPath: string;
  addressLine1: string;
  addressLine2: string;
  country: string;
  state: string;
  city: string;
  pincode: string;
  id: string;
}

export interface DateSlot {
  name: string;
  value: string | number;
  flag: boolean;
}

export interface RevenueDashboardResponse {
  paymentPendingBookingCount: number;
  paymentPending: number;
  paymentFailedBookingCount: number;
  paymentFailed: number;
  customInvoicePaymentPendingCount: number;
  customInvoicePaymentPending: number;
  customInvoicePaymentFailedCount: number;
  customInvoicePaymentFailed: number;
  message: string;
  status: boolean;
  totalRecords: number;
  data: RevenueDashboardData[];
}

export interface RevenueDashboardData {
  companyName: string;
  parkingLotName: string;
  address: string;
  dateCreated: string;
  paymentPendingCount: number;
  paymentPending: number;
  paymentFailedCount: number;
  paymentFailed: number;
  customInvoicePaymentPendingCount: number;
  customInvoicePaymentPending: number;
  customInvoicePaymentFailedCount: number;
  customInvoicePaymentFailed: number;
}
export interface DateRangeOption {
  name: string;
  value: number;
}
export interface ParkingLot {
  id: string;
  name: string;
  isActive?: boolean;
}
export interface BookingEarningDetailRequest {
  startDate: Date;
  endDate: Date;
  state: string;
  parkingLotId: string;
  timeZone: string;
}
export interface ReqManagerId {
  startDate: string;
  endDate: string;
  location: string;
  timeZone: string;
  companyId?: string;
}

export interface ResponseApiResponse {
  getBookings: GetBookingsData;
  getRevenue: GetRevenueData;
}

export interface GetBookingsData {
  total: number;
  current: number;
  upcoming: number;
  peakHoursStartTime: string;
  peakHoursEndTime: string;
  driverBookingCount: number;
  groupBookingCount: number;
  groupBookingSlotCounts: number;
  oneTimeBookingCount: number;
  revenueWithTransactionFees: number;
  revenueWithTaxAndFees: number;
}

export interface GetRevenueData {
  total: number;
  received: number;
  refunded: number;
}

export interface ApiResponseData {
  data: UserData;
}
export interface UserData {
  name: string | null;
  email: string | null;
  spentTime: number;
  earnNextVochure: number;
  recentBooking: string | null;
  company: string | null;
}

export interface FilterData {
  startdate: Date;
  enddate: Date;
  parkingLot: string[];
  invoiceNumber: string;
  paymentStatus: number;
}

export interface AddParkeUserRequest {
  groupUserId: string;
  email: string;
  name: string;
  lastName: string;
  mobileNumber: string;
  countryCode: string;
  iso: string;
}
